import React, { Component } from "react";
import "./venta.scss";
import { Col, Container, Row, Nav } from 'bootstrap-4-react';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import ItemsCarousel from 'react-items-carousel';
import Lottie from 'lottie-react-web'
import animationData from "../../../lotties/33623-piggy-bank-loop.json";
import Modal from 'react-modal'

import { ResponsiveLine } from '@nivo/line'
const customStylesModal = { content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', width: '70%', height: '70%', } };
const customStylesModalFull = { content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', width: '95%', height: '95%', } };

const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
const customStyles = {
  control: styles => ({ ...styles, backgroundColor: '#fff', height: 42, width: '90%', margin: '0 auto', marginBottom: 20, }),
}

class MainProgresoPage extends Component {
  constructor(props) {
    super(props);
    this.__getProgreso = this.__getProgreso.bind(this)
    this.state = {
      __getProgreso: this.__getProgreso,
      arraySucursales: [],
      id_sucursal: '0',
      date: moment().format('YYYY-MM-DD'),
      typeProduct: 0,
      arrDiasVenta: [],
      arrDiasGasto: [],
      totalVentas: {
        kg: 0,
        pesos: 0,
      },
      totalGastos: {
        gastos: 0,
      },
      isLoading: false,
      groupBy: 'sucursal',
      indexViewProducts: -1,

      //Carousel items
      children: [],
      activeItemIndex: 0,

      arrStock: [],
      arrCategorias: [],
      valSeach: '',
      viewTableType: 'KG',

      totalEgresoDia: 0,
      totalIngresoDia: 0,
      totalIngresoDiaBascula: 0,

      totalDisponibleVentaGlobal: 0,
      totalDisponibleBasculaGlobal: 0,
      
      viewListCaja: true,
      viewRegisterCaja: false,
      arrHistoryCaja: [],
      arrHistorySalidaVenta: [],
      arrRegisterCaja: {
        concepto: 0,
        cantidad: '',
        observacion: '',
        id_sucursal: '',
      },

      arrListVentaByDay: [],
      optTypeView: 'd',
      arrFiltroVer: [
        { optFiltroVer: 'dia', value: 'Día', active: 1, },
        { optFiltroVer: 'semana', value: 'Semana', active: 0, },
        { optFiltroVer: 'mes', value: 'Mes', active: 0, },
      ],

      finit: moment().format('YYYY-MM-DD'),
      // finit: '2021-09-24',
      ffin: moment().format('YYYY-MM-DD'),
      valueLarge: { min: 1, max: 30 },
      viewGrafica: false,
      arrDataGrafica: [],
      debug: 1,
      vistaFecha: 'normal',

      module: 'general',
      // module: 'movimientos',
      moduleMovimientos: 'historico',
      arrHistoryProductosVenta: [],
    }
  }

  __getProgreso() {
    this.getProgreso()
  }

  getDateGeneric(opt) {
    if (opt === 0)
      return (new Date())
    else {
      let d = new Date()
      // d.setMonth(5) // Junio
      // d.setDate(30)
      return new Date(d)
    }

  }

  componentDidMount() {
    this.getProgreso()
    this.props.onRef(this)
    // this.getGraficaPagos();
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  getAlert() {
    alert('clicked');
  }

  getProgreso() {
    const { id_sucursal, date, typeProduct, groupBy, finit, ffin, } = this.state

    const data = {
      user: 'admin',
      tab: this.props.initState.tabProgresoActive,
      id_sucursal,
      date,
      typeProduct,
      groupBy,

      finit,
      ffin,
    }

    fetch(this.getURLByOPT('appProgreso'), this.headersPOST({ ...data }))
      .then(response => response.json())
      .then((response) => {
        let { arraySucursales, arrDiasVenta, arrDiasGasto, } = response
        let { total_pesos, total_kg, } = arrDiasVenta

        let { id_sucursal, sucursal, } = this.props.initState.signedIn
        let flag = false
        if(id_sucursal) {
          arraySucursales = [{
            id_sucursal: id_sucursal,
            label: sucursal,
            nombre: sucursal,
            value: id_sucursal,
          }]
          flag = true
        }

        this.setState({
          arraySucursales,
          arrDiasVenta: arrDiasVenta.array,
          arrDiasGasto: arrDiasGasto.array,
          totalVentas: {
            kg: total_kg,
            pesos: total_pesos,
          },
          totalGastos: {
            gastos: arrDiasGasto.total_gastos
          },
          isLoading: false,
        })

        if(id_sucursal) {
          this.setState({ id_sucursal, })
        }

        setTimeout(() => {
          this.goToDay()
        }, 1000)

        // this.getStockAlmacen()

      }).catch((error) => console.log(error));
  }

  onChangeInfoBySuc(value) {
    this.setState({
      id_sucursal: value,
    }, this.getProgreso)
  }

  handleInputChange(data) {
    this.setState({ id_sucursal: data.id_sucursal });
    setTimeout(() => {
      this.getProgreso()
    }, 100)
  }

  getAmountByDay(type) {
    let { date, arrDiasVenta, arrDiasGasto, } = this.state
    const dia = moment(date).format('DD')

    if (arrDiasVenta.length === 0)
      return 0

    // if(typeof arrDiasVenta[ dia - 1 ] === 'undefined')
    //   return this.nf( 0, 2 );

    if (type === 'venta') {
      return this.nf(arrDiasVenta[dia - 1].venta_pesos, 2)
    } else if (type === 'gasto') {
      return this.nf(arrDiasGasto[dia - 1].valor, 2)
    } else if (type === 'utilidad') {
      return this.nf(arrDiasVenta[dia - 1].venta_pesos - arrDiasGasto[dia - 1].valor, 2)
    }

    return 0
  }

  changeActiveItem(activeItemIndex) {
    this.setState({ activeItemIndex });
  }

  makeInfoHome() {
    const hh = parseInt(moment().format('HH'))
    let inicial = '',
    { nombre, } = this.props.initState.signedIn

    if(hh > 1 && hh < 12)
      inicial += 'Buenos días,'
    else if(hh > 12 && hh < 19)
      inicial += 'Buenas tardes,'
    else
      inicial += 'Buenas noches,'

    return `${inicial} ${nombre}.`
  }

  render() {
    let { arraySucursales, viewVendidoGastoGlobal, viewListCaja, viewRegisterCaja, arrRegisterCaja, arrHistoryCaja,
      totalEgresoDia, totalIngresoDia, totalDisponibleVentaGlobal, totalDisponibleBasculaGlobal,
      totalIngresoDiaBascula, arrListVentaByDay, date, totalVentas, arrStock, arrCategorias, valSeach, viewTableType,
      arrFiltroVer, finit, ffin, valueLarge, optTypeView, module,vistaFecha } = this.state
    const porcMeta = this.getProgressMeta()
    const { RTDirector, signedIn } = this.props.initState

    let cantidadDisponible = 0,
      cantidadSalidaDinero = 0,
      cantidadSalidaDineroBascula = 0

    arrHistoryCaja.map((t) => {
      if (t.id_motivo == 4) {
        cantidadSalidaDinero += parseFloat(t.valor) 
      } else if (t.id_motivo == 5) {
        cantidadSalidaDineroBascula += parseFloat(t.valor) 
      } else {
        cantidadDisponible += (t.valor * -1)
      }
    })

    if (!this.state.arrHistoryCaja)
      return <div className="directorPage__wrapper" style={{ marginTop: 150, }}> <p>Cargando...</p> </div>

    let acumuladorVentasRango = 0;

    let totalGastos = 0
    arrHistoryCaja.map(t => {
      if(t.id_motivo >= 3)
        totalGastos += parseFloat(t.valor);
    })
    return (
      <div className="directorPage__wrapper" style={{ backgroundColor: '#fff', borderRadius: '' }}>
        {/* Principal div */}
          <Row>
            <div className="initialPage__principalContainer" style={{ backgroundColor: 'transparent', }}>
              <Row>
                <Col xs={8} md={8} lg={8}>
                  <h3 style={{ fontWeight: '300', color: '#13a407', fontWeight: '500' }}>{this.makeInfoHome()}</h3>
                  <p style={{ fontWeight: '300', fontSize: '.8rem', cursor: 'pointer', }} onClick={ () => {
			localStorage.removeItem('multiservicios_app_s'); window.location.reload();
		  } }>Cerrar sesion</p>
                </Col>
                <Col className={'ws__adm_sucursal_selector'}>
                  { arraySucursales.length > 1 ? (
                    <select onChange={(ev) => { this.onChangeInfoBySuc(ev.target.value) }}>
                      { arraySucursales.map((t,e) => (
                        <option key={`suc_${e}`} value={t.id_sucursal}>{t.nombre}</option>
                      )) }
                    </select>
                  ) : null }
                </Col>
              </Row>

              <Nav pills>
                <Nav.ItemLink active={(module==='general') ? true : false} href="#"
                onClick={
                  (e) => { this.setState({ module:'general' }) }
                }
                >General</Nav.ItemLink>
                <Nav.ItemLink href="#" active={(module==='movimientos') ? true : false}
                onClick={
                  (e) => { this.setState({ module:'movimientos' }) }
                }
                >Movimientos</Nav.ItemLink>
                <Nav.ItemLink href="#" active={(module==='caja') ? true : false}
                onClick={
                  (e) => { this.setState({ module:'caja' }) }
                }
                >Caja</Nav.ItemLink>
              </Nav>


              {
                ( vistaFecha === "normal" ) ?
                <div className="mb-1" style={{ marginTop: 20, }}>
                  <div className="row">
                    <div className="col-12">
                      <button style={{ display: 'block', textAlign: 'center', }} className={'btn btn-multiservicios1 btn-center-filterday'} onClick={() => { this.setState({ vistaFecha: 'avanzada' }) }}>Búsqueda por rango de fecha</button>
                    </div>
                    <div style={{margin: '0 auto'}}>
                      <Row>
                        <Col className="ventaPage__colHeader" style={{}}>
                          <img style={{ width: 30, height: 30, cursor: 'pointer', float: 'right' }} onClick={() => this.changeDate('-') } src={'img/pos/arrow.png'} />
                        </Col>
                        <Col className="ventaPage__colHeader" style={{}}>
                          <p style={{ textAlign: 'center', fontWeight: '800', fontSize: '1.6rem', margin: 0, }}>
                            { optTypeView === 'm' ? moment(finit).format('MM/YYYY') : moment(finit).format('DD/MM/YYYY') }
                          </p>
                        </Col>
                        <Col className="ventaPage__colHeader" style={{}}>
                          <img style={{ width: 30, height: 30, cursor: 'pointer', float: 'left', transform: 'rotate(180deg)' }} onClick={() => this.changeDate('+') } src={'img/pos/arrow.png'} />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
                : ( vistaFecha === "avanzada" ) ?
                <div className="mb-1" style={{ marginTop: 20, }}>
                  
                  <div className="row">
                    <div className="col-12">
                      <button style={{ display: 'block', textAlign: 'center', }} className={'btn btn-multiservicios1 btn-center-filterday'} onClick={() => { this.setState({ vistaFecha: 'normal' }) }}>Búsqueda normal</button>
                    </div>
                    <div className="mb-3 col-sm-4">
                      <input type="date" value={finit} className="form-control"
                        onChange={(event) => {
                          arrFiltroVer.map(( t => t.active = 0) );
                          this.setState({ finit: event.target.value, arrFiltroVer });
                        }}              
                      />
                    </div>

                    <div className="mb-3 col-sm-4">
                      <input type="date" value={ffin} className="form-control"
                        onChange={(event) => {
                          arrFiltroVer.map(( t => t.active = 0) );
                          this.setState({ ffin: event.target.value, arrFiltroVer });
                        }}              
                      />
                    </div>

                    <div className="mb-3 col-sm-4">
                      <button onClick={() => { this.getProgreso() }} className="btn btn-primary">Buscar</button>
                    </div>
                  </div>
                </div>
                : null
              }    

              

              {/* ./TIPO DE VISTA DE FECHA NORMAL O AVANZADA */}

              { module === 'general' ? this.makeViewGeneral(totalGastos, totalVentas, cantidadDisponible, totalEgresoDia, totalDisponibleVentaGlobal, cantidadSalidaDinero, totalDisponibleBasculaGlobal, totalIngresoDia, totalIngresoDiaBascula, cantidadSalidaDineroBascula) : null }
              { module === 'movimientos' ? this.makeViewMovimientos(viewTableType, optTypeView, valSeach, arrCategorias) : null }
              { module === 'caja' ? this.makeViewCaja(viewListCaja,arrHistoryCaja,viewRegisterCaja,arrRegisterCaja) : null }

              {/*
              <Row>
                <Col>
                  <button style={{ cursor: 'pointer' }} className={'btn btn-multiservicios1'} onClick={() => { this.setState({viewVendidoGastoGlobal: !viewVendidoGastoGlobal, }) }}>Vista: {viewVendidoGastoGlobal ? 'global': 'por fecha'}</button>
                </Col>
              </Row>

              <Row>
                <Col style={{ textAlign: 'center', marginTop: 20, }}>
                  {RTDirector.text != '' ? (
                    <p><b>{RTDirector.text}</b></p>
                  ) : null}
                </Col>
              </Row>

              <Row>
                <Col>
                  <button style={{ cursor: 'pointer' }} className={'btn btn-primary'} onClick={() => { this.setState({viewTableType: viewTableType == 'KG' ? 'PESOS' : 'KG'}) }}>VISTA: {viewTableType.toUpperCase()}</button>
                </Col>
              </Row>
            */}
            <Row>
              <Col>
                <button style={{ cursor: 'pointer' }} className={'btn btn-primary'} onClick={() => { this.setState({viewTableType: viewTableType == 'KG' ? 'PESOS' : 'KG'}) }}>VISTA: {viewTableType.toUpperCase()}</button>
              </Col>
            </Row>

            </div>
          </Row>

        <Modal
          overlayClassName="Overlay__aplicaciones"
          isOpen={this.state.isOpenViewListDay}
          onRequestClose={() => { this.setState({ isOpenViewListDay: false }) }}
          style={customStylesModal}
          contentLabel=""
        >
          <div className="modalBody__operador">
            <Row className="modalBody__corte">
              <Col>
                <h4>Reporte de venta diaria por producto.</h4>
                <Row>
                  <Col xs={2}>
                    <p>Hora</p>
                  </Col>
                  <Col>
                    <p>Concepto</p>
                  </Col>
                  <Col>
                    <p>KG registrados</p>
                  </Col>
                  <Col>
                    <p>Cantidad compra / venta</p>
                  </Col>
                  <Col>
                    <p>P. Unitario</p>
                  </Col>
                  <Col>
                    <p>Opciones</p>
                  </Col>
                </Row>

                {
                  this.state.isOpenViewListDay && arrListVentaByDay.map((t, e) => (
                    <Row className={'ws__listNthChild'} key={`lrow-${e}`}>
                      <Col xs={2}>
                        <p>{moment(t.fecha).format('HH:mm')}</p>
                      </Col>
                      <Col>
                        <p>{t.type.toUpperCase()}</p>
                      </Col>
                      <Col>
                        <p>{this.nf(t.kg, 2)}</p>
                      </Col>
                      <Col>
                        <p>${this.nf(t.venta_pesos, 2)}</p>
                      </Col>
                      <Col>
                        <p>${this.nf(t.precio_unitario, 2)}</p>
                      </Col>
                      <Col>
                        <p onClick={() => { this.setDeleteVentaByID(t) }} style={{ cursor: 'pointer', }}>Eliminar</p>
                      </Col>
                    </Row>
                  ))
                }

              </Col>
            </Row>
          </div>
        </Modal>

        <Modal
          overlayClassName="Overlay__aplicaciones"
          isOpen={this.state.isOpenViewListVentas}
          onRequestClose={() => { this.setState({ isOpenViewListVentas: false }) }}
          style={customStylesModalFull}
          contentLabel=""
        >
          <div className="modalBody__operador">
            <Row className="modalBody__corte">
              <Col>
                <h4>Reporte general de compra / venta.</h4>

                <div className="table-responsive">
                  <table className="table table-sm table-striped mt-2">
                    <thead>
                      <tr>
                        <th>Hora</th>
                        <th>Producto</th>
                        <th>KG registrados</th>
                        <th>Cantidad venta</th>
                        <th>P. Unitario</th>
                        <th>Acumulado</th>
                      </tr>
                    </thead>
                    <tbody>
                      { this.state.isOpenViewListVentas && arrListVentaByDay.map((t, e) => {
                        acumuladorVentasRango += parseFloat(t.venta_pesos)


                        return (
                          (
                            <tr key={`ltr-${e}`}>
                              <td>{moment(t.fecha).format('HH:mm')}</td>
                              <td>{t.nombre.toUpperCase()}</td>
                              <td>{this.nf(t.kg, 2)}</td>
                              <td>${this.nf(t.venta_pesos, 2)}</td>
                              <td>${this.nf(t.precio_unitario, 2)}</td>
                              <td>${this.nf(acumuladorVentasRango, 2)}</td>
                            </tr>
                          )
                        )

                      }) }
                    </tbody>
                  </table>
                </div>
                <hr />
                {/*<b style={{ display: 'block', textAlign: 'right', }}>Total: ${this.getCantidadTotal(arrListVentaByDay)}</b>*/}
                <b style={{ display: 'block', textAlign: 'right', }}>Total: ${this.nf(acumuladorVentasRango,2)}</b>

              </Col>
            </Row>
          </div>
        </Modal>

      </div>
    );
  }

  makeViewGeneral(totalGastos, totalVentas, cantidadDisponible, totalEgresoDia, totalDisponibleVentaGlobal, cantidadSalidaDinero, totalDisponibleBasculaGlobal, totalIngresoDia, totalIngresoDiaBascula, cantidadSalidaDineroBascula) {
    return (
      <>
        <Row>
          <Col className="ventaPage__colTypes">
            <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Acumulado</b></p>
            <p style={{ marginBottom: 0, }}><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem', }}>${this.nf(totalVentas.pesos, 2)}</b></p>
            {/*<p style={{ marginBottom: 0, }}><b style={{ fontWeight: '400', color: '#111', fontSize: '.9rem', }}>{months[moment(date).format('MM') - 1]} {moment(date).format('YY')}</b></p>*/}
          </Col>
          <Col className="ventaPage__colTypes">
            <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Disponible</b></p>
            <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${this.nf((cantidadDisponible - totalEgresoDia), 2)}</b></p>
          </Col>
          <Col onClick={() => { this.getResumenVentaGral('compra') }} className="ventaPage__colTypes">
            <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Comprado</b></p>
            <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${this.nf(totalEgresoDia, 2)}</b></p>
          </Col>
          <Col className="ventaPage__colTypes">
            <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Gastos</b></p>
            <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${this.nf(totalGastos, 2)}</b></p>
          </Col>
        </Row>

        <hr />
        <Row>
          <Col onClick={() => { this.getResumenVentaGral('venta') }} className="ventaPage__colTypes">
            <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Vendido</b></p>
            <p>
              <b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>
                Global: ${this.nf(totalDisponibleVentaGlobal, 2)}
              </b>
              <br />
              <b style={{ fontWeight: '400', color: '#777', fontSize: '.8rem' }}>
                Entrada: ${this.nf(totalIngresoDia,2)}
              </b> / <b style={{ fontWeight: '400', color: '#777', fontSize: '.8rem' }}>
                Salida: ${this.nf(cantidadSalidaDinero,2)}
              </b>
            </p>
          </Col>
          <Col onClick={() => { this.getResumenVentaGral('bascula') }} className="ventaPage__colTypes">
            <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Báscula</b></p>
            <p>
              <b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>
                Global: ${this.nf(totalDisponibleBasculaGlobal, 2)}
              </b>
              <br />
              <b style={{ fontWeight: '400', color: '#777', fontSize: '.8rem' }}>
                Entrada: ${this.nf(totalIngresoDiaBascula,2)}
              </b> / <b style={{ fontWeight: '400', color: '#777', fontSize: '.8rem' }}>
                Salida: ${this.nf(cantidadSalidaDineroBascula,2)}
              </b>
            </p>
          </Col>
        </Row>
        
      </>
    )
  }

  makeViewMovimientos(viewTableType, optTypeView, valSeach, arrCategorias) {
    const { moduleMovimientos, arrHistoryProductosVenta, } = this.state

    return (
      <>

        <Nav pills>
          <Nav.ItemLink active={(moduleMovimientos==='historico') ? true : false} href="#"
          onClick={
            (e) => { this.setState({ moduleMovimientos:'historico' }) }
          }
          >Histórico</Nav.ItemLink>
          <Nav.ItemLink href="#" active={(moduleMovimientos==='general') ? true : false}
          onClick={
            (e) => { this.setState({ moduleMovimientos:'general' }) }
          }
          >General</Nav.ItemLink>
        </Nav>


        {
          moduleMovimientos === 'historico' ? (
            <Col sm={12} md={12} lg={12} style={{ marginTop: 25, }}>
              <div className="ws-box-content">
                <h4 className="mb-4">Movimientos por fecha ({arrHistoryProductosVenta.length})</h4>
                <div className="table-responsive">
                  <table className="table table-sm table-striped mt-2">
                    <thead>
                      <tr>
                        <th>Producto</th>
                        <th>Sucursal</th>
                        <th>Tipo</th>
                        <th>PZA/KG</th>
                        <th>Total</th>
                        {/*<th>Total compra</th>
                        <th>Utilidad bruta</th>*/}
                        <th>Fecha</th>
                        {/*<th>Opción</th>*/}
                      </tr>
                    </thead>
                    <tbody>
                      {
                        arrHistoryProductosVenta.map((t,e) => (
                          <tr key={`ltrr-${e}`}>
                            <td><b>{t.nombre.toUpperCase()}</b></td>
                            <td>{t.sucursal}</td>
                            <td>{t.type.toUpperCase()}</td>
                            <td>{this.nf(t.venta_kg)}</td>
                            {/*<td>${this.nf(t.venta_pesos * t.venta_kg)}</td>
                            <td>${this.nf(t.venta_pcompra * t.venta_kg)}</td>*/}
                            <td>${this.nf(t.venta_pesos)}</td>
                            <td>{t.hora}</td>
                            {/*<td><b className={'text text-danger'} style={{ cursor: 'pointer', }}>Eliminar</b></td>*/}
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          ) : null
        }




        { moduleMovimientos === 'general' && arrCategorias.map((t0, e0) => (
          <div key={`dalmacen-${e0}`} className={'ws__list_categorias_almacen'}>
            <Row className={`ws__list_categorias_almacen_p ${(t0.show && t0.list.length > 0) ? 'active' : ''}`} onClick={() => { this.onExpandSectionCate(t0, e0) }}>
              <Col>
                <p>{t0.nombre}</p>
              </Col>
              <Col>
                <p style={{ fontSize: '.8rem', textAlign: 'right', }}>({this.nf(t0.list.length, 0)}) productos</p>
              </Col>
            </Row>

            {
              t0.show && t0.list.length > 0 ? (
                <div className={'ws__searchcnt'}>
                  <input
                    type={'text'}
                    onChange={(event) => { this.setState({ valSeach: event.target.value }) }}
                    placeholder={'Buscar un producto...'}
                    style={{ width: '100%', border: 0, backgroundColor: '#f3f3f3', padding: 4, borderRadius: 4, }}
                  />
                </div>
              ) : null
            }

            {
              t0.show && t0.list.length > 0 && viewTableType === 'KG' ? (
                <table className="table table-hover table-sm">
                  <thead>
                    <tr>
                      <th >Nombre</th>
                      <th style={{ textAlign: 'center', }}>Ingresos {optTypeView === 'm' ? 'del mes' : 'de hoy'}</th>
                      <th style={{ textAlign: 'center', }}>Salidas {optTypeView === 'm' ? 'del mes' : 'de hoy'}</th>
                      <th style={{ textAlign: 'center', }}>Existencia</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      t0.list.map((t, e) => (
                        <>
                          {
                            valSeach === '' ||
                              t.clave.toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ||
                              t.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ? (
                              <tr key={"item_" + e} onClick={() => this.onLoadInfoByDay(t, e)} style={{ cursor: 'pointer', }}>
                                <td><p style={{ padding: '0', margin: '0' }}>{t.nombre}</p></td>
                                <td style={{ textAlign: 'center', }}><p>{this.nf(t.day_compra_kg, 2)}</p></td>
                                <td style={{ textAlign: 'center', }}><p>{this.nf(t.day_venta_kg, 2)}</p></td>
                                <td style={{ textAlign: 'center', }}><p>{this.nf((t.compra_kg - t.venta_kg) - t.salida_kg, 2)}</p></td>
                              </tr>
                            ) : null
                          }
                        </>
                      ))
                    }
                  </tbody>
                </table>
              ) : null
            }

            {
              t0.show && t0.list.length > 0 && viewTableType === 'PESOS' ? (
                <table className="table table-hover table-sm">
                  <thead>
                    <tr>
                      <th >Nombre</th>
                      <th style={{ textAlign: 'center', }}>Salidas {optTypeView === 'm' ? 'del mes' : 'de hoy'}</th>
                      <th style={{ textAlign: 'center', }}>Ingresos {optTypeView === 'm' ? 'del mes' : 'de hoy'}</th>
                      <th style={{ textAlign: 'center', }}>Cantidad global</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      t0.list.map((t, e) => (
                        <>
                          {
                            valSeach === '' ||
                              t.clave.toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ||
                              t.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ? (
                              <tr key={"item_" + e} onClick={() => this.onLoadInfoByDay(t, e)}>
                                <td><p style={{ padding: '0', margin: '0' }}>{t.nombre}</p></td>
                                <td style={{ textAlign: 'center', }}><p>${this.nf(t.day_compra_pesos, 2)}</p></td>
                                <td style={{ textAlign: 'center', }}><p>${this.nf(t.day_venta_pesos, 2)}</p></td>
                                <td style={{ textAlign: 'center', }}><p>${this.nf(t.compra_pesos, 2)}</p></td>
                              </tr>
                            ) : null
                          }
                        </>
                      ))
                    }
                  </tbody>
                </table>
              ) : null
            }

          </div>

        )) }
      </>
    )
  }

  makeViewCaja(viewListCaja,arrHistoryCaja,viewRegisterCaja,arrRegisterCaja) {
    let total = 0, totalApertura = 0, totalReingreso = 0;
    const { arraySucursales } = this.state

    arrHistoryCaja.map(t => {
      if(t.id_motivo >= 3)
        total += parseFloat(t.valor);
      else if(t.id_motivo == 1)
        totalApertura += parseFloat(t.valor) * -1;
      else if(t.id_motivo == 2)
        totalReingreso += parseFloat(t.valor) * -1;
    })
    return (
      <>
        <Col sm={12} md={12} lg={12} style={{ marginTop: 25, }}>
          <div className="ws-box-content">
            <h4 className="mb-4">Movimientos de caja ({arrHistoryCaja.length})</h4>
            <h6 style={{ margin: 3, }} className="mb-4">Total gastos: ${this.nf(total)}</h6>
            <h6 style={{ margin: 3, }} className="mb-4">Total apertura: ${this.nf(totalApertura)}</h6>
            <h6 style={{ margin: 3, }} className="mb-4">Total reingresos a caja: ${this.nf(totalReingreso)}</h6>
            <div className="table-responsive">
              <table className="table table-sm table-striped mt-2">
                <thead>
                  <tr>
                    <th>Concepto</th>
                    <th>Hora</th>
                    <th>Cantidad</th>
                    <th>Opción</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    arrHistoryCaja.map((t,e) => (
                      <tr key={`${e}`}>
                        <td>
                          <p style={{ padding: 0, margin: 0, color: '#000', fontWeight: 600, }}>{t.nombre}</p>
                          {t.observacion !== '' ? <p style={{ padding: 0, margin: 0, color: '#333', fontWeight: 400, fontSize: '.85rem', whiteSpace: 'pre', }}>{t.observacion}</p> : null}
                        </td>
                        <td style={{ textAlign: 'center', }}><p>{t.hora}</p></td>
                        <td style={{ textAlign: 'center', }}><p>{this.nf((t.valor * -1), 2)}</p></td>
                        <td onClick={() => { this.setDeleteCaja(t) }}><b className={'text text-danger'} style={{ cursor: 'pointer', }}>Eliminar</b></td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        </Col>
        <button className={'btn btn-multiservicios1'} style={{ margin: '0 auto', display: 'block', marginBottom: 15, }} onClick={() => { this.setState({ viewRegisterCaja: !viewRegisterCaja, }) }}>Nuevo movimiento en caja</button>
        {
          viewRegisterCaja ? (
            <Row>
              <Col xs={4}>
                <select
                  style={{ padding: 5, background: '#f3f3f3', border: 0, }}
                  onChange={(event) => { arrRegisterCaja.concepto = event.target.value; this.setState({ arrRegisterCaja }) }}
                  >
                  <option value={'0'} disabled={'disabled'} selected={'selected'}>Selecciona un concepto</option>
                  <option value={'1'}>Apertura del día</option>
                  <option value={'2'}>Reingreso en caja</option>
                  <option value={'3'}>Gastos</option>
                  <option value={'4'}>Salida de dinero</option>
                  <option value={'5'}>Salida de dinero de báscula</option>
                </select>
                <br />
                {
                  this.props.initState.signedIn.id_usuario == 'director' ? (
                    <>
                      { arraySucursales.length > 1 ? (
                        <select 
                          style={{ padding: 5, background: '#f3f3f3', border: 0, }}
                          onChange={(ev) => {
                            if(ev.target.value == '0') {
                              alert('Por favor, elige una sucursal.')
                              arrRegisterCaja.id_sucursal = "";
                            } else {
                              arrRegisterCaja.id_sucursal = ev.target.value;
                            }
                            this.setState({arrRegisterCaja})
                          }}>
                          { arraySucursales.map((t,e) => (
                            <option key={`suc_${e}`} value={t.id_sucursal}>{t.nombre}</option>
                          )) }
                        </select>
                      ) : null }
                    </>
                  ) : null
                }
              </Col>
              <Col>
                <input
                  style={{ width: '100%', padding: 4, background: '#e7e7e7', border: '1px solid #c3c3c3', borderRadius: 4, }}
                  value={arrRegisterCaja.cantidad} placeholder={'Ingresa una cantidad'} type={'number'}
                  onChange={(event) => { arrRegisterCaja.cantidad = event.target.value; this.setState({ arrRegisterCaja }) }}
                />
                {
                  arrRegisterCaja.concepto === '3' || arrRegisterCaja.concepto === '4' ? (
                    <textarea
                      placeholder={'Ingresa una observación'}
                      onChange={(event) => { arrRegisterCaja.observacion = event.target.value; this.setState({ arrRegisterCaja }); }}
                      value={arrRegisterCaja.observacion}
                      style={{ width: '100%', border: 1, backgroundColor: '#f3f3f3', padding: 4, borderRadius: 4, minHeight: 100, }}
                    >
                    </textarea>
                  ) : null
                }
              </Col>
              <Col xs={2}>
                <p className={'btn btn-secondary'} onClick={() => { this.setRegisterNewCaja() }}>Registrar</p>
              </Col>
            </Row>
          ) : null

        }
      </>
    )
  }

  getCantidadTotal(arrListVentaByDay) {
    let total = 0;
    for (var a in arrListVentaByDay) {
      total = parseFloat(arrListVentaByDay[a].venta_pesos) + total

      if (a == (arrListVentaByDay.length - 1))
        return this.nf(total, 2);
    }

  }

  onExpandSectionCate(t, e) {
    let { arrCategorias, } = this.state
    arrCategorias[e].show = !arrCategorias[e].show
    this.setState({ arrCategorias, valSeach: '', })
  }

  setDeleteVentaByID(t) {
    var opcion = window.confirm("¿Estás seguro que deseas eliminar esta orden?");
    if (opcion == true) {
      const { id_produccion, } = t
      fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp.php?opt=setDeleteVentaByID", this.headersPOST({ id_produccion, }))
        .then(response => response.json())
        .then((response) => {
          alert('Orden eliminada con éxito')
          this.setState({
            isOpenViewListDay: false,
          })
          this.goToDay()
        })
    }
  }

  setDeleteCaja(t) {
    const { id_corte, } = t
    var opcion = window.confirm("¿Estás seguro que deseas eliminar esta orden?");
    if (opcion == true) {
      fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp.php?opt=setDeleteCaja", this.headersPOST({ id_corte, }))
      .then(response => response.json())
      .then((response) => {
        this.goToDay()
      })
    }
  }

  onLoadInfoByDay(t, e) {
    let data = {
      id_producto: t.id_producto,
      id_categoria: '',
      id_sucursal: this.state.id_sucursal,
      day: t.fecha,
    }

    fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp.php?opt=getInfoVentasByDay", this.headersPOST({ ...data, }))
      .then(response => response.json())
      .then((response) => {
        this.setState({
          isOpenViewListDay: true,
          arrListVentaByDay: response,
        })
        // console.log(response)
        // this.props.mainsetState({ arrProductos: response.arrProductos, });
        // this.setState({ isLoading: false, findProducts: (response.arrProductos.length == 0 ? false : true) })
      })

  }

  setRegisterNewCaja() {
    const { arrRegisterCaja, date, } = this.state,
    { id_sucursal, } = this.props.initState.signedIn
    if(arrRegisterCaja.id_sucursal == '')
      arrRegisterCaja.id_sucursal = id_sucursal

    if (arrRegisterCaja.concepto < 1) {
      alert('Por favor, define un concepto.')
      return false
    } else if (arrRegisterCaja.cantidad === '' || arrRegisterCaja.cantidad === 0) {
      alert('Por favor, ingresa una cantidad.')
      return false
    }

    if (arrRegisterCaja.concepto === '3' && arrRegisterCaja.observacion === '') {
      alert('Por favor, registra una observación.')
      return false
    }

    fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp?opt=setRegisterNewCaja", this.headersPOST({ arrRegisterCaja }))
      .then(response => response.json())
      .then((response) => {
        // console.log( response )
        this.setState({
          arrRegisterCaja: {
            concepto: 0,
            cantidad: '',
            observacion: '',
            id_sucursal: '',
          },
          viewRegisterCaja: false,
        })
        this.goToDay()
      })
  }

  setExportExcel() {
    const { arrStock, date, } = this.state
    fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp?opt=exportExcel", this.headersPOST({ arrStock, date: moment(date).format('DD/MM/YYYY') }))
      .then(response => response.json())
      .then((response) => {
        // console.log( response )
      })
  }

  getResumenVentaGral(type) {
    const { finit, ffin, optTypeView, } = this.state
    let data = {
      id_sucursal: '5f206899a20c8',
      finit,
      ffin,
      type,
    }

    fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp?opt=getResumenVentaGral", this.headersPOST({ ...data }))
      .then(response => response.json())
      .then((response) => {
        this.setState({
          isOpenViewListVentas: true,
          arrListVentaByDay: response,
        })
      })
  }

  getGraficaPagos() {
    const data = {
      id_categoria: '',
      id_producto: ''
    }
    fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp?opt=getGraficaPagos", this.headersPOST({ data }))
      .then(response => response.json())
      .then((response) => {
        this.setState({
          arrDataGrafica: response.data
        })
      })
  }

  getStockAlmacen() {
    this.setState({ arrStock: [], arrCategorias: [], })
    const { optTypeView, date, id_sucursal, } = this.state
    let opt;
    if (optTypeView === 'm')
      opt = 'month'
    else
      opt = 'day'

    fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp?opt=getStockAlmacen", this.headersPOST({ id_sucursal, fecha_init : this.state.finit, fecha_fin: this.state.ffin }))
      .then(response => response.json())
      .then((response) => {
        let { productos, categorias, venta, gasto_venta, venta_bascula, gasto_bascula, arrHistoryProductosVenta, } = response
        let gral_day_compra_pesos = 0, gral_day_venta_pesos = 0, gral_existencia_kg = 0,
          gral_existencia_pesos = 0, gral_day_venta_pesos_bascula = 0

        productos.map((t) => {
          // cantidadDisponible += ( t.valor * -1 )
          gral_existencia_kg = (((t.compra_kg - t.venta_kg) - t.salida_kg) + gral_existencia_kg)
          gral_existencia_pesos = (((t.compra_pesos - t.venta_pesos) - t.salida_pesos) + gral_existencia_pesos)
          gral_day_compra_pesos = (t.day_compra_pesos + gral_day_compra_pesos)
          // gral_day_venta_pesos = (t.day_venta_pesos + gral_day_venta_pesos)

          if (t.type === 6) {
            gral_day_venta_pesos_bascula = (t.day_venta_pesos + gral_day_venta_pesos_bascula)
          } else {
            gral_day_venta_pesos = (t.day_venta_pesos + gral_day_venta_pesos)
          }

        })

        let totalEgresoDia = gral_day_compra_pesos
        let totalIngresoDia = gral_day_venta_pesos
        let totalIngresoDiaBascula = gral_day_venta_pesos_bascula
        this.setState({
          arrCategorias: categorias, arrStock: productos, totalEgresoDia, totalIngresoDia, totalIngresoDiaBascula,
          arrHistoryProductosVenta,
          totalDisponibleVentaGlobal: (venta - gasto_venta),
          totalDisponibleBasculaGlobal: (venta_bascula - gasto_bascula),

        })
      })
  }


  onInfoBySucursal(t, e) {
    let { tabsArray, arrSucursalSelected } = this.props.initState

    for (var a in tabsArray) {
      tabsArray[a].active = 0
      if (tabsArray[a].index === 2) {
        //Sección sucursal
        tabsArray[a].active = 1
      }
    }
    this.props.initsetState({ arrSucursalSelected: { e, t }, tabsArray, })

  }

  getProgressMeta() {
    let utilidad = this.getAmountByDay('utilidad')
    let meta = 0

    if (utilidad !== 0) {
      utilidad = utilidad.replace('$', '').replace(',', '')
      meta = ((utilidad / 15000) * 100)
    }

    return {
      porc: (meta > 100 ? 100 : meta) + '%',
      val: meta
    }
  }

  changeDate(opt) {
    let { finit } = this.state

    if(opt == '+')
      finit = moment(finit).add(1,'days').format('YYYY-MM-DD');
    else
      finit = moment(finit).add(-1,'days').format('YYYY-MM-DD');

    this.setState({
      finit,
      ffin: finit,
    }, this.getProgreso)
    
  }

  goToDay() {
    const { finit, ffin, id_sucursal, } = this.state
    this.getStockAlmacen()

    let opt;
    if (this.state.optTypeView === 'm')
      opt = 'month'
    else
      opt = 'day'

    fetch('https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp?opt=getListadoVentaByDia', this.headersPOST({ fecha_init : finit, fecha_fin: ffin, version: '06', opt, id_sucursal, }))
    .then(response => response.json())
    .then((response) => {
      let { arrHistoryCaja, } = response
      this.setState({
        arrHistoryCaja: arrHistoryCaja.data,
        arrHistorySalidaVenta: arrHistoryCaja.data_venta,
      })
    }).catch((error) => console.log(error));

  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  nf(number, decimals, decPoint, thousandsSep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 2 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return '' + (Math.round(n * k) / k)
        .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    return s.join(dec)
  }

  uniqid() {
    var pr = '', en = false, result; this.seed = function (s, w) { s = parseInt(s, 10).toString(16); return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s; }; result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5); if (en) { result += (Math.random() * 10).toFixed(8).toString(); } return result;
  }

  getColorByIndex(e) {
    const color = ['#F0F4FE', '#A7CDF2', '#E2EFE3', '#8FAEE3', '#F0F4FE', '#A7CDF2', '#E2EFE3', '#8FAEE3']
    return color[e]
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/${PHP}?opt=${opt}`
  }

};

export default withRouter(MainProgresoPage)
